import { Element, useNode } from "@craftjs/core";
import * as React from "react";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Iframe from "@/components/editor/primitives/iframe/iframe-component";
import Text from "@/components/editor/primitives/text/text-component";
import ScheduleSettings from "@/components/editor/shared/schedules/schedule-settings-component";
import endpoints from "@/utils/endpoints";

import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "../../block-wrapper";

interface Props {
  slug: string;
}

const get = endpoints();

export default function EmbeddedSchedule(props: Props) {
  const {
    connectors: { connect },
    id,
  } = useNode();

  const src = `${get("HOPIN_ROOT")}/widgets/schedule/${
    props.slug
  }?headerEnabled=false&filtersEnabled=true`;

  return (
    <Wrapper ref={connect} id={id}>
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <div className="mb-10 flex justify-center">
            <Element
              id="title"
              is={Text}
              text="Schedule highlights"
              element="h2"
              pattern="headingTwo"
            />
          </div>
          <Iframe src={src} title="Schedule" />
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(BlockBackgroundColorWrapper)`
  iframe {
    width: 100%;
  }
`;

EmbeddedSchedule.craft = {
  custom: {
    displayName: "Embedded Schedule",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: () => ScheduleSettings({ type: "embedded" }),
  },
};
